
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { MatCommonModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';

import { PepperiModule } from '@pepperi/lib';
import { PepperiIconModule, PepperiIconRegistry, pepperiIconSystemEdit } from '@pepperi/lib/icon';
import { PepperiTextboxIconModule } from '@pepperi/lib/textbox-icon';
import { PepperiFieldTitleModule } from '@pepperi/lib/field-title';

import { PepperiTextboxComponent} from './textbox.component';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        // Material modules,
        MatCommonModule,
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule,
        MatIconModule,
        // Pepperi modules
        PepperiModule,
        PepperiIconModule,
        PepperiFieldTitleModule,
        PepperiTextboxIconModule
    ],
    exports: [PepperiTextboxComponent, ],
    declarations: [PepperiTextboxComponent],
})
export class PepperiTextboxModule {
    constructor(private pepperiIconRegistry: PepperiIconRegistry) {
        this.pepperiIconRegistry.registerIcons([
            pepperiIconSystemEdit
        ]);
    }
}
